import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import Project from "./pages/Project";
import PrivateArea from "./pages/PrivateArea";
import Notfound from "./pages/Notfound";
import './i18n';

ReactDOM.render(
  <React.StrictMode>
      <Router>
          <Switch>
              <Route exact path="/" component={App} />
              <Route path="/project/:id" component={Project} />
              <Route path="/privateArea" component={PrivateArea} />
              <Route component={Notfound} />
          </Switch>
      </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
